import type { ProductionDetail, Status } from "./api";

export type Section = "declared" | "materials" | "documents" | "manual" | "review";
export type SectionState = "done" | "partial" | "empty" | "locked";
export const SECTIONS: Array<{ key: Section; label: string }> = [
  { key: "declared", label: "Declared SKUs" }, { key: "materials", label: "Materials & pulls" },
  { key: "documents", label: "Documents" }, { key: "manual", label: "Manual lines" }, { key: "review", label: "Review" },
];
export function editable(status: Status): boolean { return status === "Draft" || status === "Computed"; }
export function plannedOnly(status: Status): boolean { return status === "Planned"; }
export function sectionState(detail: ProductionDetail, section: Section): SectionState {
  const { production, lines, usage, documents, manual_lines } = detail;
  if (plannedOnly(production.status) && section !== "declared") return "locked";
  switch (section) {
    case "declared": return lines.length === 0 ? "empty" : lines.every((line) => line.declared_qty !== null || production.status === "Planned") && !detail.flags.some((flag) => flag.code === "bom_missing") ? "done" : "partial";
    case "materials": {
      if (production.path === "B") return "locked";
      const mine = usage.filter((row) => row.supplied_by === "ketosource");
      if (mine.length === 0) return lines.length === 0 ? "locked" : "empty";
      if (mine.every((row) => row.pull_status === "pulled")) return "done";
      return mine.some((row) => row.actual_qty !== null) ? "partial" : "empty";
    }
    case "documents": return documents.length === 0 ? "empty" : "done";
    case "manual": return manual_lines.length === 0 ? "empty" : "done";
    case "review": return production.status === "Draft" ? (sectionState(detail, "materials") === "done" || production.path === "B" ? "empty" : "locked") : production.status === "Planned" ? "locked" : "done";
  }
}
export function stateGlyph(state: SectionState): string { return state === "done" ? "●" : state === "partial" ? "◐" : state === "empty" ? "○" : "🔒"; }
export function headerBanner(detail: ProductionDetail): string | null {
  const { production, lines } = detail;
  if (production.status === "Rejected" && production.rejected_reason) return `Arnold rejected: ${production.rejected_reason}`;
  if (production.status === "Awaiting Arnold") return "Awaiting Arnold. Recall it to make a change.";
  if (production.status === "Posted") return "Posted. This production is final; open the log for its history.";
  if (production.status !== "Planned" && lines.some((line) => line.planned_qty !== null) && production.target_date) return `Started from the plan of ${production.target_date} · this row reads Posted when Arnold approves`;
  return null;
}
export function canCancel(detail: ProductionDetail): boolean {
  return detail.production.status === "Draft" && detail.pulls.every((pull) => pull.void_event_id !== null);
}
export function requiredStep(detailsRequired: unknown): string | null {
  const map: Record<string, string> = { start: "Start the production first.", compute: "Compute first.", recall: "Recall it from Arnold first.", reopen: "Reopen it first." };
  return typeof detailsRequired === "string" ? map[detailsRequired] ?? `Call ${detailsRequired} first.` : null;
}
